import React from 'react';

interface Props {
    progress?: number;
}
const Spinner = ({progress}: Props) => {
    return (
        <div className={'flex justify-center items-center absolute top-0 left-0 bottom-0 right-0 m-auto'}>
            <div className={'flex justify-center items-center relative'}>
                {/* Spinner SVG */}
                <svg className="animate-spin h-8 w-8 text-orange-400" xmlns="http://www.w3.org/2000/svg"
                     fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                            strokeWidth="4"/>
                    <path className="opacity-75" fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                </svg>
                {/* Progress Text */}
                {progress && <span className={'absolute text-xs text-orange-400'}
                       style={{top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                                    {progress}%
                                </span>}
            </div>
        </div>
    );
};

export default Spinner;